import { createFileRoute, redirect } from '@tanstack/react-router';
import { beforeLoadSignupSubRoute } from 'router/utils';
import { resolveStatusScreen } from 'router/validateLeadStatus';

/**
 * `/status` is a pure dispatcher — it never renders. It reads the Lead,
 * computes the Status screen, and redirects to the screen's own URL. It
 * stays alive forever as the stable, unknown or stale `/status/$statusScreen` URLs self-heal by
 * bouncing back through here.
 */
export const Route = createFileRoute('/_signup/status/')({
  beforeLoad: ({ context, location, preload, cause }) =>
    beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validation: {
        validate: ({ lead }) => !!lead?.businessEmail,
        redirectTarget: '/',
      },
      validateLeadStatus: (leadStatus, leadStatusReason) => {
        const screen = resolveStatusScreen(leadStatus, leadStatusReason);

        if (screen === null) {
          throw redirect({ to: '/', replace: true });
        }

        throw redirect({
          to: '/status/$statusScreen',
          params: { statusScreen: screen },
          replace: true,
        });
      },
    }),
});
